var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3726 34.2206L42.971 46.754C45.6454 51.834 51.8846 53.697 56.9066 50.9152C61.9286 48.1334 63.8317 41.7601 61.1572 36.6801L54.5588 24.1467L36.3726 34.2206ZM53.2876 21.7321L46.6891 9.19843C44.0147 4.11844 37.7755 2.2554 32.7535 5.03722C27.7315 7.81904 25.8284 14.1923 28.5028 19.2723L35.1014 31.806L53.2876 21.7321Z",
    fill: "#F2F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8244 22.4374L15.8819 52.6862C23.6678 53.9596 31.207 48.8653 33.0426 40.8676C34.8782 32.8698 30.3463 24.8605 22.8244 22.4374ZM13.7993 52.1915L20.7453 21.9271C12.9201 20.5865 5.3176 25.6912 3.47327 33.727C1.62893 41.7629 6.21289 49.8104 13.7993 52.1915Z",
    fill: "#F2F2FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductImagePlaceholder);
export default __webpack_public_path__ + "static/media/product-image-placeholder.27f68888fb0768a31f4eb226f07addd2.svg";
export { ForwardRef as ReactComponent };